import { ProfileModel } from '../../api/Argentia/endpoints/profiles/model/profiles'
import {
  apiCreateProfile,
  apiDeleteProfileById,
  apiGetIsCodeDuplicated,
  apiGetIsUsedInAnyLead,
  apiGetProfileById,
  apiGetProfileByLeadType,
  apiGetProfileByType,
  apiUpdateProfile
} from '../../api/Argentia/endpoints/profiles/profiles.api'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../helpers/serviceResponseHelper'
import { ServiceResponse } from '../../model/serviceResponse'

export const getProfileById = async (
  profileId: number
): Promise<ServiceResponse<ProfileModel | undefined>> => {
  return await apiGetProfileById(profileId)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchProfilesByType = async (
  commodity: number,
  profileType: number
): Promise<ServiceResponse<ProfileModel[] | undefined>> => {
  return await apiGetProfileByType(commodity, profileType)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchProfilesByLeadType = async (
  commodity: number,
  breakdownLevel: number
): Promise<ServiceResponse<ProfileModel[] | undefined>> => {
  return await apiGetProfileByLeadType(commodity, breakdownLevel)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

// Check if the profile code is duplicated
export const fetchIsCodeDuplicated = async (
  profileCode: string,
  profileID: number | undefined
): Promise<ServiceResponse<boolean | undefined>> => {
  return await apiGetIsCodeDuplicated(profileCode, profileID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const saveNewProfile = async (
  newProfile: ProfileModel
): Promise<ServiceResponse<ProfileModel | undefined>> => {
  return await apiCreateProfile(newProfile)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const updateProfile = async (
  updatedProfile: ProfileModel
): Promise<ServiceResponse<ProfileModel | undefined>> => {
  return await apiUpdateProfile(updatedProfile)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const deleteProfileById = async (
  profileID: number
): Promise<ServiceResponse<ProfileModel | undefined>> => {
  return await apiDeleteProfileById(profileID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchIsUsedInAnyLead = async (
  profileID: number
): Promise<ServiceResponse<boolean | undefined>> => {
  return await apiGetIsUsedInAnyLead(profileID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}
